import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const BASE_URI = SERVER_URI + '/play-points';
const GET_PLAY_POINT = SERVER_URI + '/get-play-points';
const CHANGE_PLAY_POINT_STATUS = SERVER_URI + '/play-point-status/';
const UPDATE_PLAY_POINT_STATUS = SERVER_URI + '/play-points/';


export default {

    addPlayPoints:async function(paylaod)
    {
      //console.log("play pint payload", paylaod)
      return apiPost(BASE_URI,paylaod)
    },
    getPlayPoint: async function (paylaod) {
        //console.log("member payload", paylaod)
        return apiPost(GET_PLAY_POINT, paylaod);
      },
      changePlayPointStatus: async function (id) {
        return apiGet(CHANGE_PLAY_POINT_STATUS + id);
    
      },
      updatePlayPointStatus: async function (id,payload) {
        //console.log("immd.....", id,payload)
        return apiPut(UPDATE_PLAY_POINT_STATUS +id,payload)
      }
    


};